import { toast } from "sonner";
import { Undo2 } from "lucide-react";
import { undo } from "@/store";
export function showUndoToast(message, icon) {
  toast(message, {
    icon,
    action: {
      label: <span className="flex items-center gap-2">
                    <Undo2 className="h-3 w-3" /> Undo
                </span>,
      onClick: () => {
        if (undo()) toast("Undone", {
          icon: <Undo2 className="h-4 w-4" />
        });
      }
    }
  });
}
